import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { useModals } from '@shared/contexts';

import { Button } from '@components/button';
import { ModalName } from '@components/modals';

import { config } from '@/config.ts';

import * as Styled from './footer.styled';
import { getFooterData } from './get-footer-data.ts';
import { getIcon } from './get-icon.tsx';

const isRockets = config.BRAND === 'rockets';
const isNomad = config.BRAND === 'nomad';
const isBlitz = config.BRAND === 'blitz';
const isSk2 = config.BRAND === 'sk2';

const Footer = () => {
	const { t } = useTranslation(['main']);
	const { openModal } = useModals();

	const hasFooter = !isRockets && !isNomad;

	const footerData = getFooterData(config.BRAND, t);

	const handleOpenRules = () => {
		openModal(ModalName.OFFER_RULES);
	};

	if (!hasFooter) {
		return null;
	}

	if (isBlitz) {
		return '';
	}

	if (isSk2) {
		return;
	}

	return (
		<Styled.Wrapper>
			<Styled.Container>
				<Styled.Social>
					<Styled.Start>
						{footerData.apps?.map((app, index) => (
							<NavLink key={index} to={app.link} target='_blank'>
								{getIcon(app.icon)}
							</NavLink>
						))}
					</Styled.Start>
					<Styled.End>
						<Styled.SocialWrapper>
							{footerData.social?.map((socItem, index) => (
								<Styled.SocialItem key={index}>
									<NavLink to={socItem.link} target='_blank'>
										{getIcon(socItem.icon)}
									</NavLink>
								</Styled.SocialItem>
							))}
						</Styled.SocialWrapper>
					</Styled.End>
				</Styled.Social>
				<Styled.LicenseWrapper>
					{footerData?.description && <Styled.License>{footerData.description}</Styled.License>}
					<Button color='ghost' onClick={handleOpenRules}>
						{t('footer_offer')}
					</Button>
				</Styled.LicenseWrapper>
			</Styled.Container>
		</Styled.Wrapper>
	);
};

export default Footer;
